var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPossibleChallenges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9628 14.9464C17.838 13.7456 19.0646 11.7524 19.0646 9.49649C19.0646 5.82754 15.8199 2.85327 11.8175 2.85327C7.81497 2.85327 4.57031 5.82754 4.57031 9.49649C4.57031 11.7578 5.80286 13.7552 7.68571 14.955L8.00957 17.222C8.11886 17.9871 8.77409 18.5553 9.54692 18.5553H14.1003C14.8731 18.5553 15.5284 17.9871 15.6377 17.222L15.9628 14.9464ZM9.39844 20.2464C9.39844 19.9796 9.61475 19.7633 9.88158 19.7633H13.7467C14.0136 19.7633 14.2299 19.9796 14.2299 20.2464C14.2299 21.3138 13.3646 22.179 12.2973 22.179H11.331C10.2637 22.179 9.39844 21.3138 9.39844 20.2464Z",
    fill: "#F7CC74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.02344 9.64736C5.02344 6.02381 8.64697 3.30615 11.3646 3.30615C11.3646 3.30615 9.60361 3.70835 7.7411 5.57087C5.87858 7.43338 5.02344 9.64736 5.02344 9.64736Z",
    fill: "#FFAB00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.197 15.6786L17.4644 8.74405C17.4934 8.69699 17.5661 8.72197 17.56 8.7769L17.0372 13.4815C17.0338 13.5122 17.0578 13.539 17.0887 13.539H20.8165C20.8579 13.539 20.8825 13.5851 20.8596 13.6195L16.5978 20.0121C16.5675 20.0576 16.4966 20.0312 16.5034 19.977L17.0236 15.8157C17.0274 15.7848 17.0033 15.7575 16.9722 15.7575H13.2411C13.2006 15.7575 13.1758 15.7131 13.197 15.6786Z",
    fill: "#FB4141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPossibleChallenges);
export default __webpack_public_path__ + "static/media/possible-challenges.e65ff27aa6fc1d0f45dcf1a1cbbb5bd4.svg";
export { ForwardRef as ReactComponent };